"use client";
import React from "react";
import { useQuery } from "@apollo/client";
import { TRENDING_TAGS } from "@/api/apollo-client/queries/Queries";
import TrendingTags from "../TrendingTagsRightSidebar/TrendingTagsRightSidebar";

const TrendingTagsClient = () => {
  const { data, loading } = useQuery(TRENDING_TAGS, {
    variables: {
      first: 10,
      trending_duration: "HOURS_48",
    },
  });

  if (loading) return <div>Loading...</div>;
  return <TrendingTags tags={data?.trendingTags || []} />;
};

export default TrendingTagsClient;
